import ControlledSelect from "@components/hookform/Select";
import { RadioCard } from "@justhome/react-ui";
import useLanguage from "@lib/hooks/useLanguage";
import { countrySelectOptions, isEUCountry, residencePermits } from "@lib/options";
import { QualificationFormData } from "@modules/booking/context/types";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
import { useForm } from "react-hook-form";
import { Form, FormField, FormRow } from "../Form";
import FormSection from "../FormSection";
type ResidenceFormValues = Pick<QualificationFormData, "nationality" | "residencePermit">;
interface ResidenceFormProps {
  onSubmit: (data: ResidenceFormValues) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  isLoading?: boolean;
  isError?: boolean;
}
const ResidenceForm = ({
  onSubmit,
  canGoBack,
  onGoBack,
  isLoading,
  isError
}: ResidenceFormProps) => {
  const {
    t
  } = useBookingTranslation();
  const {
    control,
    register,
    handleSubmit,
    watch
  } = useForm<ResidenceFormValues>({});
  const locale = useLanguage();
  const options = countrySelectOptions(locale);
  const nationality = watch("nationality");
  const formId = "residence-form";
  return <FormSection formId={formId} canGoBack={canGoBack} onGoBack={onGoBack} isLoading={isLoading} isError={isError}>
      <Form id={formId} onSubmit={handleSubmit(onSubmit)}>
        <FormRow>
          <FormField>
            <ControlledSelect name="nationality" label={t("residenceForm.nationalityLabel")} placeholder={t("residenceForm.nationalityPlaceholder")} options={options} control={control} rules={{
            required: t("residenceForm.residenceRequiredError")
          }} />
          </FormField>
        </FormRow>

        {nationality && !isEUCountry(nationality) && <FormRow>
            <FormField columns={12}>
              <label htmlFor="residencePermit" className="block text-title-1 mb-xs">
                {t("residenceForm.residencePermitLabel")}
              </label>
              <div className="grid m:grid-cols-2 gap-3xs">
                {residencePermits.map(permit => <RadioCard key={permit} size="sm" value={permit} type="radio" {...register("residencePermit", {
              required: t("residenceForm.residencePermitRequiredError")
            })}>
                    {t(`residencePermits.${permit}`)}
                  </RadioCard>)}
              </div>
            </FormField>
          </FormRow>}
      </Form>
    </FormSection>;
};
export default ResidenceForm;